<template>
  <div v-if="item">
    <div class="row">
      <div class="col-6">
        <label>Дата</label>
        <datetime 
          v-model="date" 
          @input="init" 
          class="from-control" 
          :flow="['year', 'month']" 
          type="month" 
          :auto="true"
          format="MM/yyyy">
        </datetime>
        <blob-download :disabled="!date"
          :params="{
            year: new Date(date).getFullYear(),
            month: new Date(date).getMonth()+1,
          }" 
          :url="`${cardLink}/${id}/remainings`" 
          :name="item.name">
          Выгрузить
        </blob-download>
      </div>
    </div>
  </div>
</template>

<script>
import { cardUpdate, cardContent } from "@/plugins/functions";

export default {
  data: () => ({
    date: new Date().toISOString(),
    cardLink: "users",
    cardSetLink: "users",
    item: null,
  }),

  props: ["id"],
  async created() {
    this.item = await this.cardContent(this.cardLink, this.id);
  },
  methods: {
    cardUpdate: cardUpdate,
    cardContent: cardContent,
  },
};
</script>
<style>
</style>
